<vpg-container
    class="bn-display-flex-row-space-between ip-learn-more">
    <informative-pebble-icon
        [id]="'ip-consent-prompt'"
        [pebbleBackgroundColor]="constants.HAND_HOLDING_DOLLAR_BACKGROUND_COLOR"
        [imageUrl]="constants.HAND_HOLDING_DOLLAR_IMAGE_URL"
        [hideImageOnSmallScreen]="true">
        <p class="h4" [id]="'ip-view-account-spend'">{{'ViewAccountSpend' | translate}}</p>
        <p [id]="'ip-share-plan-info'">{{'SharePlanInfoWithUs' | translate}}</p>
    </informative-pebble-icon>
    <div class="bn-display-flex-column-justify-center consent-button">
        <button
            [id]="'ip-consent-learn-more'"
            vpg-button
            variant="secondary"
            size="medium"
            (click)="openConsentModalChange.emit(true)"
        >{{ 'LearnMore' | translate }}</button>
    </div>
</vpg-container>
